import { Arc, Multipolygon, Transform } from '@/domain/topology/Topology';
import { StaticFileCountry } from '@/secondary/country/StaticFileCountry';
import { GeoJSON, TopoJSON } from 'ol/format';
import { Country } from '@/domain/country/Country';

export interface StaticFileCountryTopology {
  type: 'Topology';
  objects: {
    entities: {
      type: 'GeometryCollection';
      geometries: Multipolygon<StaticFileCountry>[];
    };
  };
  arcs: Arc[];
  transform?: Transform;
}

const toCountryFeature = (
  staticFileCountryFeature: GeoJSON.Feature<GeoJSON.MultiPolygon, StaticFileCountry>
): GeoJSON.Feature<GeoJSON.MultiPolygon, Country> => {
  return {
    ...staticFileCountryFeature,
    properties: {
      id: staticFileCountryFeature.properties.iso3,
      name: staticFileCountryFeature.properties.name,
    },
  };
};

export const toCountryFeatureCollection = (
  staticFileCountryTopology: StaticFileCountryTopology
): GeoJSON.FeatureCollection<GeoJSON.MultiPolygon, Country> => {
  const topoJSONParser = new TopoJSON();
  const geoJSONParser = new GeoJSON();
  const staticFileCountryFeatureCollection = geoJSONParser.writeFeaturesObject(
    topoJSONParser.readFeatures(staticFileCountryTopology)
  ) as GeoJSON.FeatureCollection<GeoJSON.MultiPolygon, StaticFileCountry>;
  return { type: 'FeatureCollection', features: staticFileCountryFeatureCollection.features.map(toCountryFeature) };
};
